import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {registerLicense} from '@syncfusion/ej2-base';

if (environment.production) {
  enableProdMode();
}

// Version 20.2.40
// registerLicense('ORg4AjUWIQA/Gnt2VVhiQlFac19JXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0ViWH9WdXxXR2dUUkQ=');
// Version 20.3.49
// registerLicense('ORg4AjUWIQA/Gnt2VVhjQlFaclZJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0ViW39cc3dURWhZVUQ=');
// Version 20.1.49
//registerLicense('ORg4AjUWIQA/Gnt2VVhhQlFacF5JXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkJjX39edXFVRGlaVkU=');
// 20.4.48
// registerLicense('ORg4AjUWIQA/Gnt2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkdjXX9fdHdRQWlcWEU=');
// 24.2.9
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NAaF1cWGhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjW35YcHZRQ2VeUEByWQ==');
// 25.x.x
// registerLicense('Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXledXRWRGJcVEBwXUM=');
registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXlccHVURmFfVkZyXUc=');
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
